import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import FooterLinks from '../../components/template/FooterLinks';
import { AuthContext } from '../../store/AuthContext';
import './loginMeuCorreios.css';

const LoginMeuCorreios = () => {
  const { loginUser } = React.useContext(AuthContext);
  const { t } = useTranslation();
  const navigate = useNavigate();
  localStorage.setItem("visibleCPFData", "true");
  const faleConoscoUrl =
    'https://faleconosco.correios.com.br/cadastro/reclamacao-mc';

  return (
    <>
      <div className="conteudo">
        <div id="bem-vindo" className="card bg-superficie elev5">
          <img
            alt="Imagem de perfil da Carol"
            id="img-carol-boasvindas"
            src="/images/carol-perfil.png"
          />

          <h1>{t('login.welcome')}</h1>

          <p className="texto-apoio">
            {t('login.instruction')}
            <br />
            {t('login.instruction_numbers')}
          </p>

          <button
            id="btn-entrar"
            type="button"
            className="btn-pre primario"
            onClick={() => loginUser()}
          >
            <i className="ic-entrar"></i>
            {t('login.enter')}
          </button>

          <div className="outros-links">
            <button
              id="btn-esqueci-senha"
              className="btn-txt"
              onClick={() => navigate('/esqueciSenha')}
            >
              <i className="ic-cadeado-aberto"></i>
              {t('login.forgot_password')}
            </button>

            <button
              id="btn-cadastrar"
              className="btn-txt"
              onClick={() => navigate('/selecionaPerfil')}
            >
              <i className="ic-usuario-adicionar"></i>
              {t('login.register')}
            </button>

            <button
              id="btn-fale-conosco"
              className="btn-txt"
              onClick={() => {
                window.open(
                  faleConoscoUrl,
                  '_blank',
                  'noopener,noreferrer',
                );
              }}
            >
              <i className="ic-monitor"></i>
              {t('login.contact_us')}
            </button>
          </div>

          <p className="legenda txt-seguranca">{t('login.security_note')}</p>
        </div>
      </div>

      <FooterLinks />
    </>
  );
};
export default LoginMeuCorreios;
